module.exports = __webpack_public_path__ + "img/money-fund-dime.47936601.svg";